// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Onboarding__container-c16e4c {
  max-width: 320px;
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 12px;
  background-color: var(--addition-110_90);
  border-radius: 12px;
  align-items: center;
}

.Onboarding__arrow-ac63e1 {
  border-right: solid 6px transparent;
  border-left: solid 6px transparent;
  border-top: solid 6px var(--addition-110_90);
  transform: translateX(-50%);
  position: absolute;
  z-index: -1;
  top: 97%;
  left: 50%;
  height: 0;
  width: 0;
}

.Onboarding__content-e4e89b {
  margin-inline-end: 8px;
}

.Onboarding__title-ef1cae {
  margin-bottom: 4px;
  color: var(--addition-50);
  font: var(--body-6);
  letter-spacing: var(--font-spacing-body-6);
}

.Onboarding__description-b0e20f {
  opacity: 0.9;
  color: var(--addition-50);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.Onboarding__image-e48ec3 {
  margin-inline-end: 12px;
}

.Onboarding__image-e48ec3,
.Onboarding__icon-a75f23 {
  width: 48px;
  height: 48px;
}

.Onboarding__close-f74157 {
  width: 24px;
  height: 24px;
  align-self: flex-start;
  margin-top: -7px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Onboarding/Onboarding.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  max-width: 320px;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  padding: 12px;\n  background-color: var(--addition-110_90);\n  border-radius: 12px;\n  align-items: center;\n}\n\n.arrow {\n  border-right: solid 6px transparent;\n  border-left: solid 6px transparent;\n  border-top: solid 6px var(--addition-110_90);\n  transform: translateX(-50%);\n  position: absolute;\n  z-index: -1;\n  top: 97%;\n  left: 50%;\n  height: 0;\n  width: 0;\n}\n\n.content {\n  margin-inline-end: 8px;\n}\n\n.title {\n  margin-bottom: 4px;\n  color: var(--addition-50);\n  font: var(--body-6);\n  letter-spacing: var(--font-spacing-body-6);\n}\n\n.description {\n  opacity: 0.9;\n  color: var(--addition-50);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.image {\n  margin-inline-end: 12px;\n}\n\n.image,\n.icon {\n  width: 48px;\n  height: 48px;\n}\n\n.close {\n  width: 24px;\n  height: 24px;\n  align-self: flex-start;\n  margin-top: -7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Onboarding__container-c16e4c`,
	"arrow": `Onboarding__arrow-ac63e1`,
	"content": `Onboarding__content-e4e89b`,
	"title": `Onboarding__title-ef1cae`,
	"description": `Onboarding__description-b0e20f`,
	"image": `Onboarding__image-e48ec3`,
	"icon": `Onboarding__icon-a75f23`,
	"close": `Onboarding__close-f74157`
};
module.exports = ___CSS_LOADER_EXPORT___;
